import { all } from "redux-saga/effects";
import { reportSaga } from "./reportSaga";
import { reportNhapHocSaga } from "./reportNhapHocSaga";
import { reportTamThuSaga } from "./reportTamThuSaga";
import { tongHopSinhVienSaga } from "./tongHopSinhVienSaga";

export default function* reportSagaWrapper() {
  yield all([
    reportSaga(),
    reportNhapHocSaga(),
    reportTamThuSaga(),
    tongHopSinhVienSaga(),
  ]);
}
